import React, { useEffect } from "react";
import styles from "./index.module.css";
import Switch from '@mui/joy/Switch';
import Typography from '@mui/joy/Typography';

/**
 * DarkModeToggle Component
 * Role: Provides a toggle switch to enable/disable dark mode across the application
 * Responsibility: Manages dark mode state and applies CSS classes to document root
 */
export default function DarkModeToggle(props) {

    /**
     * Apply dark mode class to document root when isDarkMode changes
     * This enables dark mode styling across all components
     */
    useEffect(() => {
        try {
            if (props.isDarkMode) {
                document.documentElement.classList.add('dark-mode');
                // Store preference in localStorage
                localStorage.setItem('darkMode', 'enabled');
            } else {
                document.documentElement.classList.remove('dark-mode');
                localStorage.setItem('darkMode', 'disabled');
            }
        } catch (error) {
            console.error('Error applying dark mode:', error);
            console.error(error.stack);
        }
    }, [props.isDarkMode]);

    /**
     * Load dark mode preference from localStorage on component mount
     */
    useEffect(() => {
        try {
            const savedMode = localStorage.getItem('darkMode');
            if (savedMode === 'enabled' && !props.isDarkMode) {
                props.setIsDarkMode(true);
            }
        } catch (error) {
            console.error('Error loading dark mode preference:', error);
            console.error(error.stack);
        }
    }, []);

    return (
        <>
            <Switch
                checked={props.isDarkMode}
                onChange={(event) => {
                    try {
                        props.setIsDarkMode(event.target.checked);
                    } catch (error) {
                        console.error('Error toggling dark mode:', error);
                        console.error(error.stack);
                    }
                }}
                slotProps={{
                    track: {
                        children: (
                            <React.Fragment>
                                <Typography component="span" level="inherit" sx={{ ml: '8px' }}>
                                    🌙
                                </Typography>
                                <Typography component="span" level="inherit" sx={{ mr: '8px' }}>
                                    ☀️
                                </Typography>
                            </React.Fragment>
                        ),
                    },
                }}
                sx={{
                    '--Switch-thumbSize': '21px',
                    '--Switch-trackWidth': '50px',
                    '--Switch-trackBackground': props.isDarkMode ? '#1a1a2e' : '#f39c12',
                    '--Switch-thumbColor': props.isDarkMode ? '#16213e' : '#f39c12',
                }}
            />
        </>
    );
}
